import React, { useContext, useMemo } from 'react';
import DataTable from '../../../../../../common/components/DataTable';
import { IDataTableColumn } from '../../../../../../common/types/dataTable';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../../template/store';
import {
  updateSelectedDateDV,
  updateSelectedtruckerCode,
  updateSelectedPickupLocation,
  updateSelectedTruckerName,
  updateSelectedtruckerId,
  updateselectedInternalCode,
} from '../../../instructionSlice/DOExtensionSlice';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { getDateFormat } from '../../../../../../../helpers/dateFormat';
import AsyncSelect from 'react-select/async';
import { Form } from 'react-bootstrap';
import useBlCountry from '../../../../../../../hooks/useBlCountry';
import { useLinerConfig } from '../../../../../../../hooks/useLinerConfig';
import { getReleaseInstructionCountryConfig } from '../../config';
import { getCFSNameList, getTrukerNameList } from '../../../../../dashboard/actions/instruction';
import { ReleaseInstructionConfigContext } from '../../DoExtension';

interface ReleaseInstructionTableProps {
  disableFields: boolean;
  isEdit: boolean;
  selectedContainerInput: string;
  setSelectedContainerInput: React.Dispatch<React.SetStateAction<string>>;
  truckerCodearray: any[];
  setTruckerCodeArray: React.Dispatch<React.SetStateAction<any[]>>;
  releaseInstructionConfig: ReturnType<typeof getReleaseInstructionCountryConfig>;
  showPickupLocationFields: boolean;
  impHaulage: string|null;
  oblForm: any;
  blCountry: string;

}

const ReleaseInstructionTable: React.FC<ReleaseInstructionTableProps> = ({
  disableFields,
  isEdit,
  selectedContainerInput,
  setSelectedContainerInput,
  truckerCodearray,
  setTruckerCodeArray,
  releaseInstructionConfig,
  showPickupLocationFields,
  impHaulage,
  oblForm,
  blCountry
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector((state: RootState) => state.doExtension.data);
  const demurrageViewForm = useSelector(
    (state: RootState) => state.doExtension.demurrageFormView
  );
  const selectedDate = useSelector((state: RootState) => state.doExtension.selectedDate);
  const selectedTruckerCode = useSelector((state: RootState) => state.doExtension.selectedTruckerCode);
  const selectedPickupLocation = useSelector(
    (state: RootState) => state.doExtension.selectedPickupLocation
  );
  const selectedTruckerName = useSelector(
    (state: RootState) => state.doExtension.selectedTruckerName
  );
  const selectedtruckerId = useSelector(
    (state: RootState) => state.doExtension.selectedtruckerId
  );
  const selectedinternalCode = useSelector(
    (state: RootState) => state.doExtension.selectedinternalCode
  );
  const pickUpLocation = useSelector((state: RootState) => {
    const fromDoExtension = state.doExtension.pickUpLocation;
    if (fromDoExtension?.length) return fromDoExtension;
    if (state.demurrage.pickUpLocation?.length) return state.demurrage.pickUpLocation;
    return state.invoiceChange.releaseTypeList || [];
  });
  // const blCountry = useBlCountry('view', 'import', 820)[0];
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const linerConfig = useLinerConfig(blCountry, linerId, 820);
  // const releaseInstructionConfig=useContext(ReleaseInstructionConfigContext);
  const locationOptions = (inputValue: string) =>
    new Promise<any[]>((resolve) => {
      setTimeout(() => {
        dispatch(getCFSNameList({ country: blCountry, name: inputValue }))
          .unwrap()
          .then((v: any) => {
            resolve(v);
          });
      }, 2000);
    });

  const promiseOptions = (inputValue: string) =>
    new Promise<any[]>((resolve) => {
      setTimeout(() => {
        dispatch(getTrukerNameList({ name: inputValue, country: blCountry, linerId: linerId }))
          .unwrap()
          .then((v: any) => {
            resolve(v);
          });
      }, 2000);
    });

  const TableCell = (rowData: any) => {
    const { containerNo } = rowData.row.original;

    if (disableFields) {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)?.pickupDate
          }
        </span>
      );
    }
    return (
      <>
        <DatePicker
          selected={selectedDate?.[containerNo] || null}
          portalId="root-portal"
          onChange={(date) => {
            dispatch(
              updateSelectedDateDV({
                ...selectedDate,
                [containerNo]: date,
                intended: null,
              })
            );
          }}
          className="fs--2 form-control"
          timeIntervals={5}
          dateFormat={getDateFormat()}
          isClearable={true}
          popperProps={{
            strategy: 'fixed',
          }}
          disabled={
            selectedPickupLocation?.[containerNo] === '1001' &&
            (!releaseInstructionConfig?.fields?.pickupDateRequired
            && (blCountry != 'ZA' || linerId == '1'))
          }
          minDate={new Date()}
        />
        {!data?.list
          ?.map((d) => (selectedDate?.[d.containerNo] ? true : false))
          .includes(true) &&
          !selectedDate?.[containerNo] && (
            <span className="text-danger f--1 mt-1"> </span>
          )}
      </>
    );
  };

  const TableCellTruckerId = (rowData: any) => {
    const { containerNo } = rowData.row.original;

    if (!disableFields) {
      return (
        <input
          type="text"
          className="fs--2 form-control"
          // disabled={disableFields}
          disabled={true}
          title={containerNo}
          defaultValue={selectedtruckerId?.[containerNo] || ''}
          // ref={(input) => {
          //   if (input && selectedContainerInput === containerNo) {
          //     input.focus();
          //   }
          // }}
          // onFocus={() => setSelectedContainerInput(containerNo)}
          // onBlur={() => setSelectedContainerInput('')}
          onBlur={(e) => {
            e.preventDefault();
            dispatch(
              updateSelectedtruckerId({
                ...selectedtruckerId,
                [containerNo]: e.target.value,
              })
            );
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)?.truckerId
          }
        </span>
      );
    }
  };

  const TableCellInternalCode = (rowData: any) => {
    const { containerNo } = rowData.row.original;

    if (!disableFields) {
      return (
        <input
          type="text"
          className="fs--2 form-control"
          disabled={disableFields || selectedPickupLocation?.[containerNo] === '1002' ||
            (impHaulage === 'Carrier Haulage' && releaseInstructionConfig?.fields.internalCodeColumnShow)}
          title={containerNo}
          defaultValue={selectedinternalCode?.[containerNo] || ''}
          // ref={(input) => {
          //   if (input && selectedContainerInput === containerNo) {
          //     input.focus();
          //   }
          // }}
          // onFocus={() => setSelectedContainerInput(containerNo)}
          onBlur={(e) => {
            setSelectedContainerInput('');
            e.preventDefault();
            dispatch(
              updateselectedInternalCode({
                ...selectedinternalCode,
                [containerNo]: e.target.value,
              })
            );
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)?.internalCode
          }
        </span>
      );
    }
  };

  const TableCellTrucker = (rowData: any) => {
    const { blContainerId, containerNo, cntStatus, truckerCode } = rowData.row.original;
    if (
      releaseInstructionConfig?.fields?.completedStatusTruckerCode &&
      cntStatus === 'Completed'
    ) {
      return <span>{truckerCode}</span>;
    } else if (!disableFields) {
      return (
        <input
          type="text"
          className="fs--2 form-control"
          disabled={cntStatus == 'Completed' ? true : disableFields}
          title={containerNo}
          defaultValue={selectedTruckerCode?.[containerNo] || ''}
          ref={(input) => {
            if (input && selectedContainerInput === containerNo) {
              input.focus();
            }
          }}
          onFocus={() => setSelectedContainerInput(containerNo)}
          onBlur={() => setSelectedContainerInput('')}
          onChange={(e) => {
            e.preventDefault();
            dispatch(
              updateSelectedtruckerCode({
                ...selectedTruckerCode,
                [containerNo]: e.target.value,
              })
            );
            data?.list?.forEach((f: any) => {
              if (f.blContainerId === blContainerId) {
                const existingIndex = truckerCodearray.findIndex(
                  (item: any) => item.id === f.blContainerId
                );
                if (existingIndex !== -1) {
                  setTruckerCodeArray((prevArray: any) => {
                    const newArray = [...prevArray];
                    newArray[existingIndex] = {
                      value: e.target.value,
                      id: f.blContainerId,
                    };
                    return newArray;
                  });
                } else {
                  setTruckerCodeArray((prevArray: any) => [
                    ...prevArray,
                    { value: e.target.value, id: f.blContainerId },
                  ]);
                }
              }
            });
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)?.truckerCode
          }
        </span>
      );
    }
  };

  const TableCellReturnLocation = (rowData: any) => {
    const { containerNo } = rowData.row.original;

    if (!disableFields) {
      if (
        // releaseInstructionConfig?.fields?.pickupLocationDateMandate ||
        releaseInstructionConfig?.fields?.pickupLocationColumnWide
      ) {
        return (
          <div style={{ zIndex: 999 }}>
            <AsyncSelect
              menuPortalTarget={document.body}
              noOptionsMessage={({ inputValue }) => {
                return inputValue ? 'No options' : 'Type to search';
              }}
              classNames={{
                control: (state) => {
                  return `dropControl fs--1 asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
                },
              }}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({}),
              }}
              cacheOptions
              onChange={(e: any) => {
                dispatch(
                  updateSelectedPickupLocation({
                    ...selectedPickupLocation,
                    [containerNo]: e?.cfsName ?? '',
                    location: null,
                  })
                );
                if (!e?.cfsName) {
                  dispatch(
                    updateSelectedTruckerName({
                      ...selectedTruckerName,
                      [containerNo]: null,
                      location: null,
                    })
                  );
                  dispatch(
                    updateSelectedtruckerId({
                      ...selectedtruckerId,
                      [containerNo]: null,
                      location: null,
                    })
                  );
                  dispatch(
                    updateselectedInternalCode({
                      ...selectedinternalCode,
                      [containerNo]: null,
                    })
                  );
                  dispatch(
                    updateSelectedDateDV({
                      ...selectedDate,
                      [containerNo]: null,
                    })
                  );
                }
              }}
              value={{
                label: selectedPickupLocation?.[containerNo] || '',
                value: selectedPickupLocation?.[containerNo] || '',
              }}
              loadOptions={locationOptions}
              isDisabled={disableFields}
              isClearable={true}
            />
          </div>
        );
      }
      return (
        <Form.Select
          disabled={disableFields}
          value={selectedPickupLocation?.[containerNo] || ''}
          onChange={(e) => {
            dispatch(
              updateSelectedPickupLocation({
                ...selectedPickupLocation,
                [containerNo]: e.target.value,
                location: null,
              })
            );
            dispatch(
              updateSelectedTruckerName({
                ...selectedTruckerName,
                [containerNo]: null,
                location: null,
              })
            );
            dispatch(
              updateSelectedtruckerId({
                ...selectedtruckerId,
                [containerNo]: null,
                location: null,
              })
            );
            dispatch(
              updateselectedInternalCode({
                ...selectedinternalCode,
                [containerNo]: null,
              })
            );
            dispatch(
              updateSelectedDateDV({
                ...selectedDate,
                [containerNo]: null,
              })
            );
          }}
          className="fs--1 form-control form-select"
        >
          {pickUpLocation.map((option: any) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </Form.Select>
      );
    } else {
      return (
        <span>
          {
          // releaseInstructionConfig?.fields?.pickupLocationRawValue ||
          releaseInstructionConfig?.fields?.pickupLocationColumnWide
            ? demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)
                ?.pickupLocation
            : pickUpLocation.find(
                (v: any) =>
                  demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)
                    ?.pickupLocation === v?.value.toString()
              )?.text}
        </span>
      );
    }
  };

  const TableCellTruckerName = (rowData: any) => {
    const { containerNo } = rowData.row.original;
    if (selectedTruckerName?.[containerNo]) {
      promiseOptions(selectedTruckerName?.[containerNo]);
    }

    if (!disableFields) {
      return (
        <div style={{ zIndex: 999 }}>
          <AsyncSelect
            menuPortalTarget={document.body}
            noOptionsMessage={({ inputValue }) => {
              return inputValue ? 'No options' : 'Type to search';
            }}
            classNames={{
              control: (state) => {
                return `dropControl fs--1 asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
              },
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({}),
            }}
            cacheOptions
            onChange={(e: any) => {
              dispatch(
                updateSelectedTruckerName({
                  ...selectedTruckerName,
                  [containerNo]: e?.truckerName,
                  location: null,
                })
              );
              dispatch(
                updateSelectedtruckerId({
                  ...selectedtruckerId,
                  [containerNo]: e?.truckerId,
                  location: null,
                })
              );
              dispatch(
                updateselectedInternalCode({
                  ...selectedinternalCode,
                  [containerNo]: e?.internalCode,
                })
              );
            }}
            value={{
              label: selectedTruckerName?.[containerNo] || '',
              value: selectedTruckerName?.[containerNo] || '',
            }}
            loadOptions={promiseOptions}
            isDisabled={
              selectedPickupLocation?.[containerNo] === '1002' ||
              (impHaulage === 'Carrier Haulage' &&
                releaseInstructionConfig?.fields?.carrierHaulageTruckerDisabled)
            }
            isClearable={true}
          />
        </div>
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.((f: any) => f?.cntNo === containerNo)?.truckerName
          }
        </span>
      );
    }
  };

  const contactDetailsColumns: IDataTableColumn[] = useMemo(
    () => [
      {
        accessor: 'blContainerId',
        Header: 'blContainerId',
      },
      {
        accessor: 'containerNo',
        Header: t('resource_2:containerNo'),
        width: 200,
        maxWidth: 150,
      },
      // PIL MZ - New Feature: Hide Pickup Location column
      {
        accessor: 'pickupLocation',
        Header: t('resource_2:pickupLocation'),
        width: (releaseInstructionConfig?.fields.pickupLocationColumnWide || releaseInstructionConfig?.fields.pickupLocationColumnWideForPilZa) ? 250 : 178,
        maxWidth: (releaseInstructionConfig?.fields.pickupLocationColumnWide || releaseInstructionConfig?.fields.pickupLocationColumnWideForPilZa) ? 250 : 178,
        Cell: TableCellReturnLocation,
      },
      !releaseInstructionConfig?.fields.intendedDateHidden
        ? {
            accessor: 'IntendedDate',
            Header: t('resource_2:IntendedDate'),
            width: 190,
            maxWidth: 190,
            Cell: TableCell,
          }
        : {
            accessor: 'IntendedDate',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
      releaseInstructionConfig?.fields.truckerCodeColumnShow
        ? {
            accessor: 'truckerName',
            Header: t('resource_2:trukerName'),
            width: 170,
            maxWidth: 170,
            Cell: TableCellTruckerName,
          }
        : { accessor: 'truckerName', Header: '', width: 0, maxWidth: 0 },
      releaseInstructionConfig?.fields.truckerIdColumnShow
        ? {
            accessor: 'truckerId',
            Header: t('resource_2:trukerId'),
            width: 170,
            maxWidth: 170,
            Cell: TableCellTruckerId,
          }
        : { accessor: 'truckerId', Header: '', width: 0, maxWidth: 0 },
      releaseInstructionConfig?.fields.internalCodeColumnShow
        ? {
            accessor: 'internalCode',
            Header: t('resource_2:internalCode'),
            width: 170,
            maxWidth: 170,
            Cell: TableCellInternalCode,
          }
        : {
            accessor: 'internalCode',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
      !releaseInstructionConfig?.fields.truckerCodeColumnShow
        ? {
            accessor: 'truckerCode',
            Header:
              releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPKG'
                ? t('resource_3:ledger_acc_number') + ' '
                : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPEN'
                  ? t('resource_2:dic_number') + ' '
                  : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels &&
                      (oblForm?.pod === 'MYPGU' || oblForm?.pod === 'MYTPP')
                    ? t('resource_3:forward_agent_code') + ' '
                    : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYKUA'
                      ? t('') + ' '
                      : t('resource_2:truckerCode') + ' ',
            width: 178,
            maxWidth: 178,
            Cell: TableCellTrucker,
          }
        : {
            accessor: 'truckerCode',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
      releaseInstructionConfig?.fields?.cntStatusColumnShow
        ? {
            accessor: 'cntStatus',
            Header: t('resource_1:status'),
            width: 150,
            maxWidth: 150,
          }
        : {
            accessor: 'cntStatus',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
      releaseInstructionConfig?.fields?.requestedOnColumnShow
        ? {
            accessor: 'requestedOn',
            Header: t('resource_1:requested'),
            width: 150,
            maxWidth: 150,
            Cell: (rowData: any) => {
              const { requestedOn } = rowData.row.original;
              return (
                <span>
                  {requestedOn
                    ? moment(
                        moment.utc(requestedOn + 'UTC', 'YYYY-MM-DDTHH:mm:SS').toDate()
                      ).format('YYYY-MM-DD HH:mm')
                    : ''}
                </span>
              );
            },
          }
        : {
            accessor: 'requestedOn',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
      releaseInstructionConfig?.fields?.approvedOnColumnShow
        ? {
            accessor: 'approvedRejectedOn',
            Header: 'Approved/Rejected',
            width: 150,
            maxWidth: 150,
            Cell: (rowData: any) => {
              const { approvedRejectedOn } = rowData.row.original;
              return (
                <span>
                  {approvedRejectedOn
                    ? moment(
                        moment.utc(approvedRejectedOn + 'UTC', 'YYYY-MM-DDTHH:mm:SS').toDate()
                      ).format('YYYY-MM-DD HH:mm')
                    : ''}
                </span>
              );
            },
          }
        : {
            accessor: 'approvedRejectedOn',
            Header: '',
            width: 0,
            maxWidth: 0,
          },
    ],
    [
      t,
      releaseInstructionConfig,
      oblForm?.pod,
      disableFields,
      selectedDate,
      selectedPickupLocation,
      selectedTruckerCode,
      selectedTruckerName,
      selectedtruckerId,
      selectedinternalCode,
      pickUpLocation,
      demurrageViewForm,
      selectedContainerInput,
      impHaulage,
      data,
      truckerCodearray,
      setTruckerCodeArray,
      blCountry,
      linerId
    ]
  );

  const staticHiddenCols = useMemo(() => {
    let hidden = releaseInstructionConfig?.fields?.hideColumnsForUSCA
      ? [
          'blContainerId',
          'pickupLocation',
          'truckerName',
          'internalCode',
          'truckerId',
          'cntStatus',
          'requestedOn',
          'approvedRejectedOn',
          'truckerCode',
        ]
      : releaseInstructionConfig?.fields?.hideColumnsForSGVN ||
          (releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels &&
            (oblForm?.pod === 'MYPKG' || oblForm?.pod === 'MYPGU' || oblForm?.pod === 'MYTPP'))
        ? [
            'blContainerId',
            'pickupLocation',
            'truckerName',
            'internalCode',
            'truckerId',
            'IntendedDate',
          ].concat(!isEdit && !disableFields ? ['cntStatus', 'requestedOn', 'approvedRejectedOn'] : [])
        : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPEN'
          ? ['blContainerId', 'pickupLocation', 'truckerName', 'internalCode', 'truckerId'].concat(
              !isEdit && !disableFields ? ['cntStatus', 'requestedOn', 'approvedRejectedOn'] : []
            )
          : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYKUA'
            ? [
                'blContainerId',
                'pickupLocation',
                'truckerName',
                'internalCode',
                'truckerId',
                'truckerCode',
                'IntendedDate',
              ].concat(!isEdit && !disableFields ? ['cntStatus', 'requestedOn', 'approvedRejectedOn'] : [])
            : releaseInstructionConfig?.fields?.hideColumnsForGBJOAU
              ? [
                  'blContainerId',
                  'truckerCode',
                  'cntStatus',
                  'requestedOn',
                  'approvedRejectedOn',
                ]
              : releaseInstructionConfig?.fields?.hideColumnsForKETG
                ? [
                    'blContainerId',
                    'truckerCode',
                    'cntStatus',
                    'requestedOn',
                    'approvedRejectedOn',
                    'truckerId',
                    'truckerCode',
                    'truckerName',
                    'internalCode',
                  ]
                : ['blContainerId'];

    if (
      releaseInstructionConfig &&
      (!releaseInstructionConfig?.fields?.showPickupLocationInTable || !showPickupLocationFields) &&
      !hidden.includes('pickupLocation')
    ) {
      hidden.push('pickupLocation');
    }

    return hidden;
  }, [
    releaseInstructionConfig,
    oblForm?.pod,
    isEdit,
    disableFields,
    showPickupLocationFields,
  ]);

  if (!releaseInstructionConfig || !data.list?.length) {
    return null;
  }

  return (
    <div className="col-lg-12 mb-2 demmurageTable" style={{ zIndex: 1 }}>
      {data.list?.length > 0 ? (
        <DataTable
          data={data.list}
          gridName="RELEASE_INTSRUCTION_DO_EXTENSION"
          columns={contactDetailsColumns}
          sortable={false}
          searchable={false}
          showColumnFilter={false}
          selection={false}
          perPage={10}
          pagination={false}
          showExport={false}
          uniqueFilterKey="releaseInstruction"
          autoHeight={true}
          staticHiddenCols={staticHiddenCols}
        />) : (
        ''
      )}
    </div>
  );
};

export default ReleaseInstructionTable;
